import React from "react"
import Countdown from 'react-countdown';

class Completionist extends React.Component {

  render() {
    const url = `/user_exams/${this.props.user_exam.id}/start`
    return <p>
      Your test has started. You will be redirected now. Otherwise click here {url}
    </p>
  }

}

class StartExam extends React.Component {
  constructor(props) {
    super(props);
  }

  renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      const url = `/user_exams/${this.props.user_exam.id}/start`;
      window.location.href = url;
      return <Completionist />;
    } else {
      return <h2>{days} {this.props.t['days']} {hours}h:{minutes}m:{seconds}s</h2>;
    }
  };

  render() {
    return <p>
      <Countdown date={this.props.start_time} renderer={this.renderer}/>
    </p>
  }
}

export default StartExam



// WEBPACK FOOTER //
// app/javascript/components/StartExam.js